import { useEffect, useRef } from 'react'

interface PreviewPaneProps {
    html: string
    heightClass?: string
}

/**
 * Renders server-produced HTML in a sandboxed iframe so admin-authored or
 * AI-authored markup can't touch the parent app.
 */
export function PreviewPane({ html, heightClass = 'h-[600px]' }: PreviewPaneProps) {
    const ref = useRef<HTMLIFrameElement>(null)

    useEffect(() => {
        if (ref.current) {
            ref.current.srcdoc =
                html || '<p style="color:#9A9793;padding:32px;">No preview yet</p>'
        }
    }, [html])

    return (
        <div
            className={`w-full overflow-hidden rounded-lg border border-gray-200 bg-white ${heightClass}`}
        >
            <iframe
                ref={ref}
                title="Email preview"
                sandbox="allow-same-origin"
                className="h-full w-full"
            />
        </div>
    )
}
